// Mock data for IWMC Life Coaching Website

export const siteConfig = {
  name: "Integrated Wellness",
  tagline: "Life Coaching",
  phone: "(201) 535-3582",
  email: "info@integratedwellnessny.com",
  logo: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/m7o30xhx_Logo2026.png",
  matrixEngineLink: "#", // Placeholder - update with Gamma link
  jotformIntakeLink: "https://www.jotform.com/build/260025640801041",
  explore7DomainsLink: "https://gamma.app/docs/Transform-Your-Life-Through-the-7-Domains-of-Wellness-0pjlgw8kkgxvv0a",
};

export const heroContent = {
  headline: "Transform Your Life Through the 7 Domains of Wellness",
  subheadline: "A 12-week coaching program for high-achieving professionals who feel stuck, overwhelmed, or disconnected from their purpose — integrating Physical, Emotional, Social, Vocational, Financial, Spiritual, and Environmental well-being.",
  primaryCta: "Start Your Transformation",
  secondaryCta: "Chat with Our AI Coach",
  image: "https://customer-assets.emergentagent.com/job_771f3e9b-da23-4724-a45f-65945e1d7c38/artifacts/pprbfcmf_EeiRH_JLceqQihVoAzdTS.png",
};

export const wellnessDomains = [
  {
    id: 1,
    name: "Physical",
    icon: "Heart",
    focusAreas: "Sleep, energy, movement, pain, nutrition",
    description: "How your body supports or limits your life",
    color: "#00BFFF",
  },
  {
    id: 2,
    name: "Emotional",
    icon: "Brain",
    focusAreas: "Mood, anxiety, joy, regulation",
    description: "Your inner experience and resilience",
    color: "#4A7DB8",
  },
  {
    id: 3,
    name: "Social",
    icon: "Users",
    focusAreas: "Connection, support, belonging",
    description: "Your relationships and community",
    color: "#00BFFF",
  },
  {
    id: 4,
    name: "Vocational",
    icon: "Briefcase",
    focusAreas: "Work satisfaction, burnout, purpose",
    description: "Your relationship with career",
    color: "#4A7DB8",
  },
  {
    id: 5,
    name: "Financial",
    icon: "Wallet",
    focusAreas: "Money stress, security, behaviors",
    description: "Your relationship with resources",
    color: "#00BFFF",
  },
  {
    id: 6,
    name: "Spiritual",
    icon: "Sparkles",
    focusAreas: "Meaning, values, purpose",
    description: "Connection to something bigger",
    color: "#4A7DB8",
  },
  {
    id: 7,
    name: "Environmental",
    icon: "Home",
    focusAreas: "Living space, safety, nature",
    description: "Your physical surroundings",
    color: "#00BFFF",
  },
];

export const programPhases = [
  {
    id: 1,
    phase: "Phase 1",
    title: "Discovery & Foundation",
    weeks: "Weeks 1-4",
    focus: "Assessment, relationship building, foundational habits",
    details: [
      "Week 1: Your story, rapport building, 7-domain orientation",
      "Week 2: Intake review, identify top 3 priority domains, set initial goals",
      "Weeks 3-4: Establish micro-habits, troubleshoot barriers",
    ],
    deliverable: "Personalized Wellness Blueprint",
  },
  {
    id: 2,
    phase: "Phase 2",
    title: "Activation & Building",
    weeks: "Weeks 5-8",
    focus: "Behavioral momentum, obstacle navigation, skill building",
    details: [
      "Week 5: Midpoint review, celebrate improvements, address stuck points",
      "Weeks 6-8: Deep work in priority domains, progressive habit stacking",
    ],
    deliverable: "Mid-Phase Progress Report",
  },
  {
    id: 3,
    phase: "Phase 3",
    title: "Integration & Mastery",
    weeks: "Weeks 9-12",
    focus: "Consolidation, sustainability, relapse prevention",
    details: [
      "Weeks 9-10: Identify automatic vs. fragile habits, build prevention plans",
      "Week 11: Final 7-domain reassessment",
      "Week 12: Graduation session, finalize sustainability plan",
    ],
    deliverable: "Graduation Summary and Sustainability Plan",
  },
];

export const programBenefits = [
  {
    id: 1,
    title: "Comprehensive Assessment",
    description: "Evaluate all 7 domains using the Wellness Wheel model",
    icon: "ClipboardCheck",
  },
  {
    id: 2,
    title: "Personalized Roadmap",
    description: "Customized Wellness Blueprint with micro-habits and action plans",
    icon: "Map",
  },
  {
    id: 3,
    title: "Expert Coaching Support",
    description: "Weekly Coaching Sessions Available",
    icon: "UserCheck",
  },
  {
    id: 4,
    title: "AI-Powered Accountability",
    description: "24/7 access to AI wellness assistant",
    icon: "Bot",
  },
  {
    id: 5,
    title: "Clinical Integration",
    description: "Seamless routing to medical team when needed",
    icon: "Stethoscope",
  },
];

export const aboutContent = {
  title: "About Our Approach",
  subtitle: "Whole-Person Transformation",
  description: "Our coaching philosophy integrates evidence-based practices with a warm, supportive approach. We believe you are the expert on your own life — our role is to guide, support, and empower you to achieve lasting change.",
  philosophy: [
    "Client-centered approach — you are the expert",
    "Evidence-based yet accessible methods",
    "Integration of coaching and clinical care",
    "Focus on sustainable, lasting transformation",
  ],
  image: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/az9kvk0e_y5QwOO7rtrUm2dhLTW7JD.png",
};

export const faqItems = [
  {
    id: 1,
    question: "Who is this program for?",
    answer: "Our 12-week program is designed for high-achieving professionals who feel stuck, overwhelmed, or disconnected from their purpose. If you're ready for meaningful change across multiple areas of your life, this program is for you.",
  },
  {
    id: 2,
    question: "How is this different from therapy?",
    answer: "While therapy often focuses on processing past experiences and treating mental health conditions, coaching is future-focused and action-oriented. We work on building skills, habits, and strategies to achieve your wellness goals. If clinical support is needed, we can seamlessly route you to our medical team.",
  },
  {
    id: 3,
    question: "What happens after the 12 weeks?",
    answer: "You'll graduate with a comprehensive Sustainability Plan designed to maintain your progress. We also offer maintenance check-ins and ongoing support options for continued accountability.",
  },
  {
    id: 4,
    question: "How much time do I need to commit?",
    answer: "Plan for one weekly coaching session (45-60 minutes) plus time for implementing micro-habits and action items between sessions. The AI assistant is available 24/7 for additional support.",
  },
  {
    id: 5,
    question: "Is this covered by insurance?",
    answer: "Life coaching is typically not covered by insurance. However, if clinical services are indicated, those may be eligible for coverage. Contact us to discuss payment options.",
  },
];

export const navigationLinks = [
  { name: "Home", path: "/" },
  { name: "Program", path: "/program" },
  { name: "About", path: "/about" },
  { name: "AI Coach", path: "/ai-coach" },
  { name: "Apply", path: "/apply" },
  { name: "Contact", path: "/contact" },
];

export const coachingImages = {
  hero: "https://customer-assets.emergentagent.com/job_771f3e9b-da23-4724-a45f-65945e1d7c38/artifacts/pprbfcmf_EeiRH_JLceqQihVoAzdTS.png",
  session1: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/az9kvk0e_y5QwOO7rtrUm2dhLTW7JD.png",
  session2: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/kag3w5eu_DOlI3xunSNZC-QROVODW4.png",
};

// Wellness meditation images
export const wellnessImages = {
  meditation1: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/dabi60jz_RM3KmmF_kVujNirCaugNr.png", // Spiritual light beam
  meditation2: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/diqqh9o8_SUxjr53mhmyOBwA1sAcFn.png", // Futuristic platform
  cosmic: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/5vid3t45_zyYfpQo5QeATQxFl5thH_.png", // Cosmic scene
  sacredGeometry: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/cu5lknz6_eV5p-CnphDuXSe5ZAI46u.png", // Sacred geometry
  temple: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/rickbz8i_y1xjZAFMeZU8es57vztWl.png", // Temple meditation
  luxury: "https://customer-assets.emergentagent.com/job_coach-journey-7/artifacts/pey2uu0b_5gfAmzGYphP8prgb7SF59.png", // Luxury room
};
